<template lang="pug">
  .answers
    Body

</template>

<script>
import Body from './layouts/Body';
import moment from 'moment';

export default {
  components: { Body },
  data() {
    return {
      day: -7
    };
  },
  watch: {
    '$route.query'() {
      if (!this.$route.query.date_start || !this.$route.query.date_end) {
        this.$router.push({
          query: {
            date_start: moment()
              .subtract(6, 'days')
              .day(moment().day())
              .format('YYYY-MM-DD'),
            date_end: moment().format('YYYY-MM-DD')
          }
        });
      }
      this.$store.dispatch('answersAnalyticsValidators/getValidators');
    }
  },
  mounted() {
    if (!this.$route.query.date_start || !this.$route.query.date_end) {
      this.$router.push({
        query: {
          date_start: moment()
            .subtract(6, 'days')
            .day(moment().day())
            .format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD')
        }
      });
    } else {
      this.$store.dispatch('answersAnalyticsValidators/getValidators');
    }
  },
  destroyed() {
    this.$store.dispatch('answersAnalyticsValidators/setData', {
      path: 'validatorsList',
      value: []
    });
  }
};
</script>
